import {SecureService} from "@/services/superclasses/secure-service";
import {OrganizationNumber} from "@/interfaces/organization-number";

const api = window.contextPath + '/rest/organization-numbers';

export class OrganizationNumberSecureService extends SecureService {

    public loadByMember = async (): Promise<OrganizationNumber> => {
        return this.data(await this.get<OrganizationNumber>(api + "/by-member"));
    }
}

export const organizationNumberSecureService = new OrganizationNumberSecureService()